import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsRcConstants {
    // Labels and headers
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static TYPE_LABEL = "Application type";
    static REASON_FOR_APPLICATION = "Reason for application";
    static TYPE_OF_TRANSFER_LABEL = "Type of transfer";
    static PROPERTY_TYPE_LABEL = "Property type";
    static RATES_ACCOUNT_NUMBER_LABEL = "Rates account number";
    static ELECTRONIC_REFERENCE_LABEL = "Electronic reference number";
    static ATTORNEY_REFERENCE_LABEL = "Attorney reference";
    static COUNCIL_REFERENCE_LABEL = "Council reference";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    // FormControl names
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static TYPE_FORM_CONTROL_NAME = "applicationType";
    static REASON_FOR_APPLICATION_CONTROL_NAME = "reasonForApplication";
    static TYPE_OF_TRANSFER_CONTROL_NAME = "typeOfTransfer";
    static PROPERTY_TYPE_CONTROL_NAME = "propertyType";
    static RATES_ACCOUNT_NUMBER_CONTROL_NAME = "ratesAccountNumber";
    static ELECTRONIC_REFERENCE_CONTROL_NAME = "electronicReference";
    static ATTORNEY_REFERENCE_CONTROL_NAME = "attorneyReference";
    static COUNCIL_REFERENCE_CONTROL_NAME = "councilReference";
    static REFERENCE_NUMBER_CONTROL_NAME = "referenceNumber";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        type: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        reasonForApplication: {
            required: `Reason for application ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        typeOfTransfer: {
            required: `Type of transfer ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        propertyType: {
            required: `Property type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        ratesAccountNumber: {
            required: `Rates account number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        electronicReference: {
            required: `Electronic reference ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        attorneyReference: {
            required: `Attorney reference ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        councilReference: {
            required: `Council reference ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
